import { useState, useEffect, useRef } from 'react';
import io from 'socket.io-client';
import config from 'sharedConfig';
import useInterval from 'shared/hooks/useInterval';

function createSocket({ userID, orderID, handleData }) {
  const socket = io(config.orderTracking.url);
  socket.on('connect', () =>
    socket.emit('authentication', { 'x-user-id': userID })
  );
  socket.on('authenticated', () => socket.emit('location', { start: orderID }));
  socket.on(orderID, handleData);
  return socket;
}

export function useOrderTrackingSocket({
  userID,
  orderID,
  isEnabled,
  handleData
}) {
  const handler = useRef();
  useEffect(() => {
    handler.current = handleData;
  }, [handleData]);

  useEffect(() => {
    function handleData(data) {
      if (handler.current) handler.current(data);
    }
    const socket =
      isEnabled && !!userID && !!orderID
        ? createSocket({ userID, orderID, handleData })
        : null;
    return () => socket && socket.close();
  }, [isEnabled, orderID, userID]);
}

export function useCountdown(eta = {}, interval = 60 * 1000) {
  const predictedTime = eta.time;

  function getRemainingTime() {
    if (!predictedTime) return null;
    const remainder = Math.round(
      (new Date(predictedTime) - new Date()) / (60 * 1000)
    );
    return typeof remainder === 'number' ? Math.max(0, remainder) : null;
  }

  const [remainingTime, setRemainingTime] = useState(getRemainingTime());

  useInterval(() => {
    setRemainingTime(getRemainingTime());
  }, interval);

  return remainingTime;
}
